import { render, staticRenderFns } from "./exercisesFB.vue?vue&type=template&id=6db8727c&scoped=true"
import script from "./exercisesFB.vue?vue&type=script&lang=js"
export * from "./exercisesFB.vue?vue&type=script&lang=js"
import style0 from "./exercisesFB.vue?vue&type=style&index=0&id=6db8727c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8727c",
  null
  
)

export default component.exports